(() => {
  if (!document.body.classList.contains('template-collection')) return;

  const ROOT_SEL = '#main-collection-filters';
  const PRICE_SEL = '[data-tt-price]';

  const getRoot = (scope = document) => scope.querySelector(ROOT_SEL);
  const getPrice = (root) => root && root.querySelector(PRICE_SEL);

  const getParts = (price) => {
    if (!price) return null;
    const from = price.querySelector('input[id$="Price-From"]');
    const to = price.querySelector('input[id$="Price-To"]');
    const segBtns = Array.from(price.querySelectorAll('.tt-price__seg-btn'));
    const clearBtn = price.querySelector('[data-tt-price-clear]');
    const applyBtn = price.querySelector('[data-tt-price-apply]');
    if (!from || !to || !applyBtn) return null;
    return { from, to, segBtns, clearBtn, applyBtn };
  };

  const setActiveSeg = (segBtns, key) => {
    segBtns.forEach(b => b.classList.toggle('is-active', b.dataset.ttRange === key));
  };

  // Important: DO NOT dispatch change/input until Apply is pressed.
  const stageRange = (parts, key, min, max) => {
    parts.from.value = min ?? '';
    parts.to.value = max ?? '';
    setActiveSeg(parts.segBtns, key || '');
  };

  const clearPrice = (parts) => {
    parts.from.value = '';
    parts.to.value = '';
    setActiveSeg(parts.segBtns, '');
  };

  const applyPrice = (parts) => {
    // Dawn listens to changes on inputs; fire both for safety
    parts.from.dispatchEvent(new Event('input', { bubbles: true }));
    parts.from.dispatchEvent(new Event('change', { bubbles: true }));
    parts.to.dispatchEvent(new Event('input', { bubbles: true }));
    parts.to.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const bind = (scope = document) => {
    const root = getRoot(scope);
    const price = getPrice(root);
    const parts = getParts(price);
    if (!parts) return;

    if (price.dataset.ttBound === '1') return;
    price.dataset.ttBound = '1';

    // Seg buttons (stage only)
    parts.segBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const key = btn.dataset.ttRange || '';
        const min = btn.dataset.min || '';
        const max = btn.dataset.max || '';
        stageRange(parts, key, min, max);
      });
    });

    // Clear (stage clear)
    if (parts.clearBtn) {
      parts.clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        clearPrice(parts);
      });
    }

    // Apply (submit)
    parts.applyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      applyPrice(parts);
    });

    // If user types manually, remove segment highlight (still staged)
    [parts.from, parts.to].forEach(inp => {
      inp.addEventListener('input', () => setActiveSeg(parts.segBtns, ''));
    });
  };

  // Init
  document.addEventListener('DOMContentLoaded', () => bind(document));
  document.addEventListener('shopify:section:load', (e) => bind(e.target || document));

  // Re-bind after Dawn facet DOM swaps
  const mo = new MutationObserver(() => bind(document));
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
